// 获取用户登录信息
export function list() {
    return {
        isOpen: false,
        url: '/customform/customfrom/list',
        type: 'post',
        data: {
            "pageIndex": 1,
            "pageSize": 10,
            "rows": [{
                "id": "1",
                "title": "项目明细",
                "code": "A001",
                "formType": 1,
                "createTime": '2012-01-01',
            }, {
                "id": "3",
                "title": "项目编辑",
                "code": "A001",
                "formType": 2,
                "createTime": '2012-01-01',
            }, {
                "id": "2",
                "title": "项目列表",
                "code": "A001",
                "formType": 0,
                "createTime": '2012-01-01',
            }],
            "total": 25,
            "totalItemCount": 25,
            "totalPageCount": 3
        }
    }
}